d:\project\SAAS_echargnet\src\views\AccountCoupon.vue
<template>
    <div class="search_nav">
        <el-form :inline="true" class="demo-form-inline">
            <el-form-item label="手机号：">
                <el-input v-model="formInline.userPhone" placeholder="请输入手机号" style="width: 200px;"></el-input>
            </el-form-item>
            <el-form-item label="券码：">
                <el-input v-model="formInline.couponCode" placeholder="请输入券码" style="width: 200px;"></el-input>
            </el-form-item>
            <el-form-item label="优惠券状态：">
                <el-select style="width: 150px;" v-model="formInline.status" placeholder="全部">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="未使用" :value="1"></el-option>
                    <el-option label="已使用" :value="2"></el-option>
                    <el-option label="已作废" :value="3"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <div class="button_group">
                    <el-button type="primary" @click="getList">搜索</el-button>
                    <el-button type="primary" @click="refresh">刷新</el-button>
                </div>
            </el-form-item>
        </el-form>
    </div>

    <el-table class="table_wrapper" :data="tableData" :header-cell-style="{'text-align':'left'}" :cell-style="{'text-align':'left'}">
        <el-table-column label="手机号" width="120">
            <template #default="scope">
                <span>{{ scope.row.userPhone || '-' }}</span>
            </template>
        </el-table-column>
        <el-table-column label="券码" width="200" show-overflow-tooltip>
            <template #default="scope">
                <span>{{ scope.row.couponCode || '-' }}</span>
            </template>
        </el-table-column>
        <el-table-column label="优惠券名称" width="150" show-overflow-tooltip>
            <template #default="scope">
                <span>{{ scope.row.couponName || '-' }}</span>
            </template>
        </el-table-column>
        <el-table-column label="使用门槛" width="120">
            <template #default="scope">
                <span>{{ scope.row.useThreshold || '-' }}</span>
            </template>
        </el-table-column>
        <el-table-column label="面额折扣" width="120">
            <template #default="scope">
                <span>{{ scope.row.denomination || '-' }}</span>
            </template>
        </el-table-column>
        <el-table-column label="入账时间" width="160">
            <template #default="scope">
                <span>{{ scope.row.receiveTime || '-' }}</span>
            </template>
        </el-table-column>
        <el-table-column label="到期时间" width="160">
            <template #default="scope">
                <span>{{ scope.row.expireTime || '-' }}</span>
            </template>
        </el-table-column>
        <el-table-column label="使用时间" width="160">
            <template #default="scope">
                <span>{{ scope.row.useTime || '-' }}</span>
            </template>
        </el-table-column>
        <el-table-column label="优惠券状态" width="120">
            <template #default="scope">
                <span>{{ getStatusDesc(scope.row.status) }}</span>
            </template>
        </el-table-column>
        <el-table-column label="充电订单编号" width="150" show-overflow-tooltip>
            <template #default="scope">
                <span>{{ scope.row.orderNo || '-' }}</span>
            </template>
        </el-table-column>
        <el-table-column label="备注" width="150" show-overflow-tooltip>
            <template #default="scope">
                <span>{{ scope.row.remark || '-' }}</span>
            </template>
        </el-table-column>
        <el-table-column label="操作" width="120" fixed="right">
            <template #default="scope">
                <el-button type="text" @click="showDetail(scope.row)">详情</el-button>
                <el-button v-if="scope.row.status == 1" type="text" @click="cancelCoupon(scope.row)">作废</el-button>
            </template>
        </el-table-column>
    </el-table>

    <!-- 分页 -->
    <Pagination
        v-model:current-page="currentPage"
        v-model:page-size="pageSize"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
    />

    <!-- 详情弹窗 -->
    <el-dialog v-model="showDetailModal" title="账户优惠券详情" :close-on-click-modal="false" width="600px">
        <el-form :model="detailForm" label-width="150px">
            <el-form-item label="优惠券ID">
                <span>{{ detailForm.id || '-' }}</span>
            </el-form-item>
            <el-form-item label="手机号">
                <span>{{ detailForm.userPhone || '-' }}</span>
            </el-form-item>
            <el-form-item label="券码">
                <span>{{ detailForm.couponCode || '-' }}</span>
            </el-form-item>
            <el-form-item label="优惠券名称">
                <span>{{ detailForm.couponName || '-' }}</span>
            </el-form-item>
            <el-form-item label="使用门槛">
                <span>{{ detailForm.useThreshold || '-' }}</span>
            </el-form-item>
            <el-form-item label="面额折扣">
                <span>{{ detailForm.denomination || '-' }}</span>
            </el-form-item>
            <el-form-item label="入账时间">
                <span>{{ detailForm.receiveTime || '-' }}</span>
            </el-form-item>
            <el-form-item label="到期时间">
                <span>{{ detailForm.expireTime || '-' }}</span>
            </el-form-item>
            <el-form-item label="使用时间">
                <span>{{ detailForm.useTime || '-' }}</span>
            </el-form-item>
            <el-form-item label="优惠券状态">
                <span>{{ getStatusDesc(detailForm.status) }}</span>
            </el-form-item>
            <el-form-item label="充电订单编号">
                <span>{{ detailForm.orderNo || '-' }}</span>
            </el-form-item>
            <el-form-item label="备注">
                <span>{{ detailForm.remark || '-' }}</span>
            </el-form-item>
        </el-form>
        <template #footer>
            <el-button @click="showDetailModal = false">关闭</el-button>
        </template>
    </el-dialog>
</template>

<script>
export default {
name:'AccountCoupon',
data() {
    return {
        tableData: [],
        total: 0,
        currentPage: 1,
        pageSize: 10,
        showDetailModal: false,
        formInline: {
            phone: '',
            couponCode: '',
            status: ''
        },
        detailForm: {}
    }
},
mounted(){
    this.getList();
},
methods:{
    getList(){
        let that = this;
        let param = {
            page: that.currentPage,
            pageSize: that.pageSize
        };
        Object.keys(this.formInline).forEach(key => {
            if(this.formInline[key]){
                param[key] = this.formInline[key];
            }
        });
        that.$axios.post(that.$store.state.platformApi + "user/coupon/page", JSON.stringify(param)).then(result => {
            if(result.code == 200){
                that.tableData = result.data.records;
                that.total = result.data.total;
            }
        });
    },
    handleSizeChange(val) {
        this.pageSize = val;
        this.getList();
    },
    handleCurrentChange(val) {
        this.currentPage = val;
        this.getList();
    },
    refresh() {
        this.formInline = {
            phone: '',
            couponCode: '',
            status: ''
        };
        this.currentPage = 1;
        this.getList();
    },
    showDetail(row) {
        this.detailForm = { ...row };
        this.showDetailModal = true;
    },
    cancelCoupon(row) {
        let that = this;
        that.$confirm('确认作废该优惠券吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            that.$axios.post(that.$store.state.platformApi + "user/coupon/invalidate/"+row.id, {}).then(result => {
                if(result.code == 200){
                    row.status = 3; // 已作废
                    that.$message.success('作废成功');
                }
            });
        });
    },
    getStatusDesc(status){
        switch(status){
            case 1:
                return '未使用';
            case 2:
                return '已使用';
            case 3:
                return '已作废';
            default:
                return '-';
        }
    }
}
}
</script>

<style lang="scss" scoped>
.search_nav{
    padding: 15px;
    background: #fff;
    margin-bottom: 15px;
}
.button_group{
    display: flex;
    align-items: center;
    justify-content: flex-end;
    button{
        margin-left: 10px;
    }
}
</style>